var createCanonicalLink = () => {
    function setLink() {
        const link = document.createElement('link');

        link.rel = 'canonical';
        link.href = window.location.href;

        document.head.appendChild(link);
    }

/*    window.addEventListener('load', setLink);*/

    const linksCollection = document.getElementsByTagName('link');
    const allLinks = Array.from(linksCollection);
    if (allLinks.length > 0 && allLinks.some(link => link.rel === "canonical")) return;
    setLink();
}

